import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-4 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-3">
            分类浏览
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            按<span className="text-primary-600">类型</span>探索韩漫
          </h2>
          <p className="text-sm text-foreground-500 mt-2">选择您感兴趣的分类，发现更多好看的韩国漫画</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-3">
          {categories.map(cat => (
            <Link
              key={cat.slug}
              to={cat.slug === 'all' ? '/category/all' : `/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-background-100 group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-xl text-foreground-600 group-hover:text-primary-600`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}